import { FC, ReactNode } from "react";

interface iProps {
  children: ReactNode;
}

export const Heading: FC<iProps> = ({ children }) => {
  return <h2 className="text-gray-950 font-semibold text-xl">{children}</h2>;
};
